import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
import Cookies from "js-cookie";
const ls = new SecureLS({ isCompression: false });
import cmsStore from '@/cms/store';
import feStore from '@/store/frontendStore';
import cardStore from '@/store/cardStore';
Vue.use(Vuex);
export default new Vuex.Store ({
  plugins:[
    createPersistedState({
      storage: {
        getItem: key => Cookies.get(key),
        setItem: (key, value) => Cookies.set(key, value, {expires:5,secure:(process.env.VUE_APP_SECURE_COOKIE == "false" ? false : true)}),
        removeItem: key => Cookies.remove(key)
      }
    })
  ],
  modules:{
    cmsStore,
    feStore,
    cardStore
  }
})